<template>
    <div class="position-relative">
        <VuePhoneNumberInput
            v-model="telefono"
            :data-cy="dataCy"
            :disabled="desactivar"
            :border-radius="0"
            :translations="translations"
            size="lg"
            id="phone"
            @update="formatNumber"
            @blur="tocado = true"
            @input="handleInput"
            class="mb-1 rounded-pill-input"
        />
        <span
            v-if="mostrarErrorFormato"
            class="invalid-feedback mb-4 mt-0 mt-md-3 text-xs"
            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
        >
            <b>{{ $t('formularios.formato_telefono') }}</b>
        </span>
        <span
            v-else-if="mostrarErrorObligatorio"
            class="invalid-feedback mb-4 mt-0 mt-md-3 text-xs"
            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
        >
            <b>{{ $t('formularios.telefono_obligatorio') }}</b>
        </span>
    </div>
</template>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    export default {
        props: ['phone', 'dataCy', 'desactivar', 'forceValidate', 'required'],
        data() {
            return {
                telefono: !isNaN(this.phone) ? this.phone : null,
                isValid: false,
                tocado: false,
                translations: {
                    countrySelectorLabel: this.$t('formularios.codigo_pais'),
                    phoneNumberLabel: this.$t('formularios.telefono'),
                    example: this.$t('formularios.telefono_ejemplo')
                }
            }
        },
        computed: {
            mostrarErrorObligatorio() {
                return this.required && (this.tocado || this.forceValidate) && !this.telefono
            },
            mostrarErrorFormato() {
                return this.telefono && !this.isValid
            }
        },
        methods: {
            formatNumber(infoNumber) {
                this.isValid = infoNumber.isValid
                const formattedNumber = infoNumber.countryCallingCode + infoNumber.nationalNumber

                this.$emit('setNumber', isNaN(formattedNumber) ? null : formattedNumber)

                if(!this.forceValidate && isNaN(formattedNumber)) {
                    this.$emit('validNumber', true)
                } else {
                    this.$emit('validNumber', this.isValid)
                }
            },
            handleInput() {
                this.$emit('onTyping', this.telefono)
            }
        },
        components: { VuePhoneNumberInput }
    }
</script>

<style scoped>
.rounded-pill-input {
    border-radius: 50rem !important;
    border: 1px solid #dee2e6 !important;
    transition: all 0.15s ease-in-out !important;
    background-color: white !important;
    overflow: visible !important;
}

.rounded-pill-input:focus-within {
    border-color: #86b7fe !important;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
}

:deep(.vue-phone-number-input) {
    border-radius: 50rem !important;
    overflow: visible !important;
}
.rounded-pill-input {
    border: 1px solid #dee2e6 !important;
    border-radius: 50rem !important;
}

:deep(.country-selector) {
    border-top-left-radius: 50rem !important;
    border-bottom-left-radius: 50rem !important;
    border: none !important;
    border-right: 1px solid #dee2e6 !important;
    background-color: white !important;
    padding-left: 20px !important;
    height: 62px !important;
    min-height: 62px !important;
}

:deep(.country-selector__toggle) {
    background-color: transparent !important;
}

:deep(.country-selector__input) {
    border: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
    color: #212529 !important;
}

:deep(.country-selector__label) {
    color: #6c757d !important;
}

:deep(.input-tel__input-container) {
    border-top-right-radius: 50rem !important;
    border-bottom-right-radius: 50rem !important;
    background-color: white !important;
    height: 62px !important;
    min-height: 62px !important;
}

:deep(.input-tel__input) {
    border: none !important;
    padding-left: 20px !important;
    border-top-right-radius: 50rem !important;
    border-bottom-right-radius: 50rem !important;
    background-color: white !important;
    height: 62px !important;
    min-height: 62px !important;
}

/* DROPDOWN */
:deep(.country-selector__list) {
    border-radius: 0.5rem !important;
    border: 1px solid #dee2e6 !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    background-color: white !important;
    z-index: 9999 !important;
}

/* Flecha del dropdown */
:deep(.country-selector__toggle__arrow) {
    border-top-color: #495057 !important;
}

@media screen and (min-width: 1200px) {
    :deep(.country-selector.lg.has-value .country-selector__input) {
        padding-top: 25px !important;
        height: 100% !important;
    }
    
    :deep(.input-tel.lg .input-tel__input) {
        height: 100% !important;
    }
}

.country-selector__toggle__arrow[data-v-46e105de] {
    padding-top: 8px;
}

.country-selector.lg .country-selector__label[data-v-46e105de] {
    font-size: 10px;
}

.invalid-feedback {
    position: relative;
    z-index: 1;
}
</style>
